// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Vb4u","left":"styles_left__35LbM"};